module.exports = __webpack_public_path__ + "static/media/surrogate.5fe63666.png";